import React, { ReactNode } from "react";

import styles from "./PageContainer.module.css";

function PageContainer({ children, contentPadding, pageBackground }: { children: ReactNode; contentPadding?: number; pageBackground?: string }) {
    return (
        <div className={styles.container} style={{ background: `${pageBackground}` }}>
            <div className={styles.content} style={{ padding: `0 ${contentPadding}px` }}>
                {children}
            </div>
        </div>
    );
}

export default PageContainer;
